const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchListLite({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/storage/lite`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListPro({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/storage/pro`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListStorageTeacher({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/report`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    return window.axios.put(`api/storage/${payload.storageId}`, {
      ...payload
    });
  }
};

export default { namespaced, state, getters, mutations, actions };
